import formatMoney, { toFiniteAmount } from './formatMoney'

const MONEY_TOLERANCE = 0.01

const WALLET_LOCKED_STATES = ['capturing', 'captured']

export const WALLET_PAYMENT_LABEL = 'Saldo Viatik'

const positiveAmount = value => {
  const amount = toFiniteAmount(value)
  return amount !== null && amount > 0 ? amount : 0
}

export const walletPaidAmount = transaction => {
  const walletPayment = transaction?.wallet_payment
  if (!walletPayment || walletPayment.state !== 'captured') return 0
  return positiveAmount(walletPayment.amount)
}

export const isWalletPaymentLocked = transaction =>
  WALLET_LOCKED_STATES.includes(transaction?.wallet_payment?.state)

export const isWalletCaptureInProgress = transaction => transaction?.wallet_payment?.state === 'capturing'

export const walletShareLabel = ({ walletAmount, total, currency, paidWithProvider }) => {
  const wallet = positiveAmount(walletAmount)
  if (wallet <= 0) return null
  const paidOnlyWithWallet =
    paidWithProvider === false ||
    (paidWithProvider === undefined && toFiniteAmount(total) !== null && wallet >= total - MONEY_TOLERANCE)
  return paidOnlyWithWallet ? WALLET_PAYMENT_LABEL : `Saldo ${formatMoney(wallet, currency)}`
}
